<template>
  <div class="bodyinner">
    <audioui filename="bgmusic7"></audioui>
    <loadui></loadui>
    <starui starfilename="arrow"></starui>
    <commonmokuai></commonmokuai>
    <swipermoban ref="swipermoban"></swipermoban>
    <p3 ref="p3"></p3>
    <p4 ref="p4"></p4>
    <p5 ref="p5"></p5>
    <p6 ref="p6"></p6>
  </div>
</template>
<script>

// <xuliezhen ref="xuliezhen" starttime="50" isloop="1" count=30></xuliezhen>
import { mapState } from "vuex";
import store from "@/store/";
import {
  jiazaimusicfn,
  resourcepath,
} from "../commonjs/commonfn.js";
export default {
  name: "index",

  data() {
    return {
      sad: 1,
      resourcepath: resourcepath,


    };
  },

  components: {
  },
  created() {
    window.initPage = this.initPage;
    window.refreshPage = this.refreshPage;


  },
  beforeMount() {

  },
  mounted() {
    jiazaimusicfn();
  },


  methods: {

    initPage() {
      console.log('初始化');
      
      this.tiaoshipage()



      // var head = document.getElementsByTagName('head')[0];
      // var script = document.createElement('script');

      // script.type = 'module';
      // head.appendChild(script);
      // script.src = 'http://wx.newmiracle.cn/box2dwasmtest/demo.js';
      // script.onload = function () {

      //    console.log('加载完成')
      //   //这里就是当第三方库加载成功后的代码逻辑了
      // }











     this.$refs.swipermoban.resload();
    },
    // window.refreshPage 刷新页面用的

    refreshPage() {
      //  this.$refs.swipermoban.refresh();
    },
    tiaoshipage() {

      // 调试页面用window.refreshPage 然后 initpage  issshow显示页面 resload这个只是第一次需要加载完的东西 以后不会再加载了
      //所以每次进入页面都要初始化  refreshPage只是关闭页面的作用   
     //  每个模块都要遵循  子模块 resload写只加载一次   子模块 initpage每次打开加载1次的思想    结束当然也要清理下

      // window.refreshPage();
      // store.commit('isshowp5set',1);
    },





  },
  computed: {
    ...mapState([
      "isalljiazai",
      "isActive",
      "chuangtitle",
      "suodingtipcss",
    ]),
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/index.vue